import React from "react";

/**
 * Perfil (profile) icon — silhouette person.
 * Source: src/assets/icons/perfil-icon.svg
 * Uses currentColor so active/inactive state is inherited from parent.
 */
const PerfilIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "24px",
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="16" r="8" fill={color} />
    <path
      d="M10 40 C10 32, 16 28, 24 28 C32 28, 38 32, 38 40 L38 42 C38 43, 37 44, 36 44 L12 44 C11 44, 10 43, 10 42 Z"
      fill={color}
    />
  </svg>
);

export default PerfilIcon;
